module.exports = __webpack_public_path__ + "static/media/embed.5161909e.svg";